function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.837 9.612V2.827A2.827 2.827 0 0013.01 0H2.833A2.828 2.828 0 00.005 2.827v6.785a2.828 2.828 0 002.828 2.827H13.01a2.828 2.828 0 002.827-2.827m-1.13-6.192v6.192a1.7 1.7 0 01-1.7 1.7H2.83a1.7 1.7 0 01-1.7-1.7V3.42l5.2 3.534a2.828 2.828 0 003.177 0zm-.142-1.272A1.7 1.7 0 0013.01 1.13H2.833a1.7 1.7 0 00-1.556 1.018l5.688 3.868a1.692 1.692 0 001.913 0z",
  fillRule: "evenodd"
});

function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.832 12.439",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgIconMail;